export default __webpack_public_path__ + "static/media/store_svg4.1211abff.svg";